import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});


@withStyles(styles)
class LoadingButton extends React.Component{
  static propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
    disabled: false,
  };

  render() {
    const { loading, disabled, children, classes, ...buttonProps } = this.props;
    buttonProps.disabled = loading || disabled;
    return (
      <Button {...buttonProps}>
        {children}
        {loading ? <CircularProgress size={24} className={classes.progress} /> : null}
      </Button>
    );
  }
}


export default LoadingButton;
